exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.UpdateByDate_container_1lZy {\n  margin-bottom: 24px;\n}\n@media (min-width: 768px) {\n  .UpdateByDate_container_1lZy {\n    margin-bottom: 0;\n  }\n}\n.UpdateByDate_calendar_2Ewl {\n  margin-bottom: 16px;\n}\n@media (min-width: 768px) {\n  .UpdateByDate_calendar--error_38ey {\n    margin-bottom: 48px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "UpdateByDate_container_1lZy",
	"calendar": "UpdateByDate_calendar_2Ewl",
	"calendar--error": "UpdateByDate_calendar--error_38ey"
};